import axios from 'axios';
// import store from '../store';,
function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    // list(obj = {}) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const url = `/ppnkeluarnsfp`;
    //             const { data } = await axios.get(url);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/ppnkeluarnsfp${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`ppnkeluarnsfp/detail/${obj.nsfphdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    // detail(obj = {}) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['page', 'limit', 'sortBy', 'sortDir', 'nsfphdrkey'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/ppnkeluarnsfp/detail${str}`;
    //             const { data } = await axios.get(url);
    //             const { meta, list } = data;
    //             obj.total = meta.total;
    //             resolve(list);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("ppnkeluarnsfp", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savedetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("ppnkeluarnsfp/detail", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    updateTotal(obj) {
        const { data } = axios.put(`ppnkeluarnsfp/${encodeURIComponent(obj.nsfphdrkey)}`, obj);
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`ppnkeluarnsfp/${obj.nsfphdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    removedetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`ppnkeluarnsfp/detail/${obj.nsfplinekey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['nsfphdrkey'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/ppnkeluarnsfp/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'pemakaian_nsfp.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },

};